import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconName } from "@fortawesome/free-brands-svg-icons";
import { Link, useLocation, useOutletContext } from "react-router";
import { FeedbackExternalContext } from "./context";
import { PendingSurvey, ReviewLocation } from "@/components/Feedback/feedback";
import ThankYou, {
  ReviewLocationLinks,
} from "@/components/Feedback/FeedbackThankYou";
import { Button } from "@/components/Button";

function FeedbackExternalThankYouPage() {
  const { reviewLocations = [], pendingSurvey = null } =
    (useLocation().state as {
      reviewLocations: ReviewLocation[];
      pendingSurvey?: PendingSurvey | null;
    }) || {};
  const { property } = useOutletContext<FeedbackExternalContext>();
  const { propertyName = "" } = property || {};

  let appLink = "";
  if (import.meta.env.VITE_ENVIRONMENT === "PRODUCTION") {
    appLink = "https://livly.app.link/vQbPtuiQX4";
  } else {
    appLink = "https://livly.test-app.link/28TYfYIQX4";
  }

  return (
    <div className="flex flex-col items-center max-w-lg p-4 mx-auto">
      <h2 className="text-lg font-bold text-center">Thank you!</h2>
      <p className="mt-2 text-center">
        Your living experience is important to us. Thanks for your feedback.
      </p>
      <img src="/thumbs_up.png" className="h-48 py-8" />
      {reviewLocations.length > 0 && (
        <>
          <p className="mt-2 text-center">
            Seems you are having a great time living at {propertyName}! Would
            you like to share this review on the following site? That’ll be
            really appreciated!
          </p>
          <div className="mt-4">
            <ReviewLocationLinks reviewLocations={reviewLocations} />
          </div>
        </>
      )}
      {pendingSurvey?.pendingSurveyToken && (
        <div className="w-full mt-4 pt-4 border-t border-gray-200 text-center">
          <p className="font-medium">
            {pendingSurvey.title || "We have a quick survey for you"}
          </p>
          <p className="mt-1 text-sm text-gray-600">
            {pendingSurvey.questionCount
              ? `${pendingSurvey.questionCount} question${
                  pendingSurvey.questionCount === 1 ? "" : "s"
                } — would you like to share more details?`
              : "Would you like to share more details? Take a short survey."}
          </p>
          <Link
            to={`/survey?ltoken=${pendingSurvey.pendingSurveyToken}`}
            className="block w-full mt-3"
          >
            <Button color="secondary" className="w-full">
              Take Survey
            </Button>
          </Link>
        </div>
      )}
    </div>
  );
}

export default FeedbackExternalThankYouPage;
